import { render, staticRenderFns } from "./HistoricHTMLTab.vue?vue&type=template&id=509f1976&scoped=true&"
import script from "./HistoricHTMLTab.vue?vue&type=script&lang=ts&"
export * from "./HistoricHTMLTab.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricHTMLTab.vue?vue&type=style&index=0&id=509f1976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f1976",
  null
  
)

export default component.exports